<div class="flex flex-col add-capability">
  <div class="flex flex-row justify-between items-center mb-16">
    <div class="m-0 mat-headline-5">{{'ADD_VERSION.ADD_CAPABILITY' | transloco}}</div>
    <mat-icon svgIcon="close" class="fs-32 cursor-pointer" (click)="matdialogRef.close()"></mat-icon>
  </div>

  <div>
    <form [formGroup]="addCapabilityForm" class="p-8" *ngIf="!isLoading">

      <div class="flex flex-row">
        <div class="flex flex-col form-fields mb-16 mr-16">
          <div class="flex flex-row justify-start items-center">
            <label class="mat-subtitle-2 mb-0 fs-12 fw-700">{{'ADD_VERSION.CAPABILITY' | transloco | uppercase }}</label>
            <mat-icon svgIcon="info" class="icon-sm ml-4" matTooltipClass="form-tooltip right" [matTooltip]="'ADD_VERSION.CAPABILITY' | transloco"
              matTooltipPosition="{{Constants.POSITION_RIGHT}}"></mat-icon>
          </div>
          <select (ngModelChange)="capabilitySelectionChange($event)" [formControl]="addCapabilityForm.get('capability')" class="fw-500 form-select" required >
            <option [ngValue]="null" [disabled]="true" hidden>{{'ADD_VERSION.CAPABILITY' | transloco}}</option>
            <option *ngFor="let option of components" [ngValue]="option.name">{{ option.name }}</option>
          </select>
          <app-error [control]="addCapabilityForm.get('capability')"></app-error>
        </div>
  
        <div class="flex flex-col form-fields mb-16">
          <div class="flex flex-row justify-start items-center">
            <label class="mat-subtitle-2 mb-0 fs-12 fw-700">{{'ADD_VERSION.VERSION' | transloco | uppercase }}</label>
            <mat-icon svgIcon="info" class="icon-sm ml-4" matTooltipClass="form-tooltip right" [matTooltip]="'ADD_VERSION.VERSION' | transloco"
              matTooltipPosition="{{Constants.POSITION_RIGHT}}"></mat-icon>
          </div>
          <input formControlName="version" placeholder="{{'ADD_VERSION.VERSION' | transloco}}" class="fw-500" required>
          <app-error [control]="addCapabilityForm.get('version')"></app-error>
        </div>
      </div>

      <div class="flex flex-row">
        <div class="flex flex-col form-fields mb-16 mr-16">
          <div class="flex flex-row justify-start items-center">
            <label class="mat-subtitle-2 mb-0 fs-12 fw-700">{{'ADD_VERSION.DISPLAY_NAME' | transloco | uppercase }}</label>
            <mat-icon svgIcon="info" class="icon-sm ml-4" matTooltipClass="form-tooltip right" [matTooltip]="'ADD_VERSION.DISPLAY_NAME' | transloco"
              matTooltipPosition="{{Constants.POSITION_RIGHT}}"></mat-icon>
          </div>
          <div class="flex flex-row justify-start items-center read-only-field pl-10" 
            [ngClass]="{'placeholder': !selectedCapability?.displayName}">
            {{selectedCapability?.displayName ? selectedCapability?.displayName : ('ADD_VERSION.DISPLAY_NAME' | transloco)}}
          </div>
        </div>
        <div class="flex flex-col form-fields mb-16">
          <div class="flex flex-row justify-start items-center">
            <label class="mat-subtitle-2 mb-0 fs-12 fw-700">{{'ADD_VERSION.TYPE' | transloco | uppercase }}</label>
            <mat-icon svgIcon="info" class="icon-sm ml-4" matTooltipClass="form-tooltip right" [matTooltip]="'ADD_VERSION.TYPE' | transloco"
              matTooltipPosition="{{Constants.POSITION_RIGHT}}"></mat-icon>
          </div>
          <select [formControl]="addCapabilityForm.get('type')" class="fw-500 form-select" required>
            <option [ngValue]="null" [disabled]="true" hidden>{{'ADD_VERSION.TYPE' | transloco}}</option>
            <option *ngFor="let option of typeOptions" [ngValue]="option.value">{{ option.value }}</option>
          </select>
          <app-error [control]="addCapabilityForm.get('type')"></app-error>
        </div>
      </div>

      <div class="flex flex-row">
        <div class="flex flex-col form-fields mb-16 mr-16">
          <div class="flex flex-row justify-between items-center mb-4">
            <div class="flex flex-row justify-start items-center">
              <label class="mat-subtitle-2 mb-0 fs-12 fw-700">{{'ADD_VERSION.INSTALLATION_SPECIFICATION' | transloco | uppercase }}</label>
              <mat-icon svgIcon="info" class="icon-sm ml-4" matTooltipClass="form-tooltip right" [matTooltip]="'ADD_VERSION.INSTALLATION_SPECIFICATION' | transloco"
                matTooltipPosition="{{Constants.POSITION_RIGHT}}"></mat-icon>
            </div>
            <div class="flex flex-row">
              <mat-icon [svgIcon]="showCopyIcon.installationSpecification ? 'content_copy' : 'library_add_check'" (click)="changeIcon('installationSpecification')" class="icon-md mr-8 cursor-pointer" 
                [cdkCopyToClipboard]="stringifyData(selectedCapability?.installationSpecification)"></mat-icon>
              <mat-slide-toggle [checked]="encryptionKeys.installationSpecification" (change)="encryptData($event, 'installationSpecification')">{{ (encryptionKeys.installationSpecification ? 'ADD_VERSION.DECODE' : 'ADD_VERSION.ENCODE') | transloco}}</mat-slide-toggle>
            </div>
          </div>
          <div class="read-only p-8">
            <span *ngIf="selectedCapability?.installationSpecification && checkType(selectedCapability?.installationSpecification) !== 'string'"><pre>{{selectedCapability?.installationSpecification | json}}</pre></span>
            <span *ngIf="checkType(selectedCapability?.installationSpecification) === 'string'">{{selectedCapability?.installationSpecification}}</span>
          </div>
        </div>

        <div class="flex flex-col form-fields mb-16">
          <div class="flex flex-row justify-between items-center mb-4">
            <div class="flex flex-row justify-start items-center">
              <label class="mat-subtitle-2 mb-0 fs-12 fw-700">{{'ADD_VERSION.SECRET_SPECIFICATION' | transloco | uppercase }}</label>
              <mat-icon svgIcon="info" class="icon-sm ml-4" matTooltipClass="form-tooltip right" [matTooltip]="'ADD_VERSION.SECRET_SPECIFICATION' | transloco"
                matTooltipPosition="{{Constants.POSITION_RIGHT}}"></mat-icon>
            </div>
            <div class="flex flex-row">
              <mat-icon [svgIcon]="showCopyIcon.secretSpec ? 'content_copy' : 'library_add_check'" (click)="changeIcon('secretSpec')" class="icon-md mr-8 cursor-pointer" 
                [cdkCopyToClipboard]="selectedCapability?.secretSpec"></mat-icon>
              <mat-slide-toggle [checked]="encryptionKeys.secretSpec" (change)="encryptData($event, 'secretSpec')">{{ (encryptionKeys.secretSpec ? 'ADD_VERSION.DECODE' : 'ADD_VERSION.ENCODE') | transloco}}</mat-slide-toggle>
            </div>
          </div>
          <div class="read-only p-8">
            {{selectedCapability?.secretSpec}}
          </div>
        </div>
      </div>

      <div class="flex flex-col mb-16">
        <div class="flex flex-row justify-between items-center mb-4">
          <div class="flex flex-row justify-start items-center">
            <label class="mat-subtitle-2 mb-0 fs-12 fw-700">{{'ADD_VERSION.INSTALL_PARAMETER_MAPPING' | transloco | uppercase }}</label>
            <mat-icon svgIcon="info" class="icon-sm ml-4" matTooltipClass="form-tooltip right" [matTooltip]="'ADD_VERSION.INSTALL_PARAMETER_MAPPING' | transloco"
              matTooltipPosition="{{Constants.POSITION_RIGHT}}"></mat-icon>
          </div>
          <div class="flex flex-row">
            <mat-icon [svgIcon]="showCopyIcon.installParameterMapping ? 'content_copy' : 'library_add_check'" (click)="changeIcon('installParameterMapping')" class="icon-md mr-8 cursor-pointer" 
              [cdkCopyToClipboard]="addCapabilityForm.get('installParameterMapping')?.value"></mat-icon>
            <mat-slide-toggle [checked]="encryptionKeys.installParameterMapping" (change)="encryptData($event, 'installParameterMapping')">{{ (encryptionKeys.installParameterMapping ? 'ADD_VERSION.DECODE' : 'ADD_VERSION.ENCODE') | transloco}}</mat-slide-toggle>
          </div>
        </div>
        <textarea formControlName="installParameterMapping" placeholder="{{'ADD_VERSION.INSTALL_PARAMETER_MAPPING' | transloco}}" class="fw-500 text-area" required></textarea>
        <app-error [control]="addCapabilityForm.get('installParameterMapping')"></app-error>
      </div>
    </form>

    <div *ngIf="isLoading" class="flex flex-row justify-center items-center spinner">
      <mat-spinner diameter="24"></mat-spinner>
    </div>
  </div>

  <mat-divider class="w-100-percent divider mb-16 mt-16"></mat-divider>
  <div class="flex flex-row justify-end">
    <button class="accent" type="button" (click)="createDeployment()">{{ (showEdit ? 'ADD_VERSION.EDIT' : 'ADD_VERSION.ADD') | transloco}}</button>
  </div>
</div>